import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { buildClientEntity, buildClientUrl } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import { useModal } from 'store/modal';
import UpdateEntity from 'components/crud/UpdateEntity';
import { useTranslation } from 'react-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GroupForm from '../../components/GroupForm';
import { IInputs } from '../../components/types';
import { IGroup } from '../../types';
import Employees from './Employees';
import Moderators from './Moderators';

interface IProps {
  group: IGroup;
}
const EditForm: FC<IProps> = ({ group }: IProps) => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { client } = useActiveClientContext();
  const { showModal } = useModal();

  const methods = useForm<IInputs>({
    defaultValues: {
      ...group,
    },
  });

  return (
    <Row>
      <Col md={12}>
        <UpdateEntity
          id={id}
          entity="groups"
          methods={methods}
          onSuccess={(res: any) => {
            const { name } = res.data;
            showModal({
              type: 'success',
              content: (
                <>
                  {t('structure.groups.editSuccessMsg')}&nbsp;
                  <span className="font-weight-bold text-break">{name}</span>.
                </>
              ),
            });
          }}
          queryKey={[buildClientEntity('group', client), { id }]}
          onSuccessPushToLink={buildClientUrl('/structure/groups', client)}
        >
          {(update: any) => (
            <GroupForm
              title={t('structure.groups.editTitle')}
              methods={methods}
              handleSubmit={update}
              btnLabel={t('common.save')}
            />
          )}
        </UpdateEntity>
      </Col>
      <Col md={6}>
        <Employees groupId={id} />
      </Col>
      <Col md={6}>
        <Moderators groupId={id} />
      </Col>
    </Row>
  );
};

export default EditForm;
